import { Asset, Token } from 'nftx.js';

const getRedeemableAssets = ({
  allRedeemableAssets,
  redeemableCollections,
}: {
  allRedeemableAssets: Asset[] | undefined;
  redeemableCollections: Array<Token & { vaultIds: string[] }>;
}) => {
  let assets = allRedeemableAssets;
  if (!assets?.length || !redeemableCollections.length) {
    return [];
  }
  const vaultIds = redeemableCollections.flatMap((c) => c.vaultIds);
  assets = assets.filter((asset) => {
    return asset.vaultIds.some((vaultId) => vaultIds.includes(vaultId));
  });
  return assets;
};

export default getRedeemableAssets;
